function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2451 19.6364H10.4149C8.2579 19.6364 6.50928 21.3947 6.50928 23.5636V36.6545C6.50928 38.8235 8.2579 40.5818 10.4149 40.5818H31.2451C33.4022 40.5818 35.1508 38.8235 35.1508 36.6545V23.5636C35.1508 21.3947 33.4022 19.6364 31.2451 19.6364Z",
  fill: "#FBCB51"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3682 19.6364V9.81817C12.3682 7.56142 13.2597 5.3971 14.8467 3.80134C16.4337 2.20557 18.5861 1.30908 20.8304 1.30908C23.0748 1.30908 25.2272 2.20557 26.8142 3.80134C28.4011 5.3971 29.2927 7.56142 29.2927 9.81817V19.6364H26.6889V9.81817C26.6889 8.25581 26.0717 6.75743 24.973 5.65267C23.8743 4.54791 22.3842 3.92726 20.8304 3.92726C19.2767 3.92726 17.7865 4.54791 16.6879 5.65267C15.5892 6.75743 14.9719 8.25581 14.9719 9.81817V19.6364H12.3682Z",
  fill: "#AABFCE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.1321 32.0728C22.1321 32.42 21.9949 32.753 21.7508 32.9985C21.5066 33.244 21.1755 33.3819 20.8302 33.3819C20.4849 33.3819 20.1538 33.244 19.9096 32.9985C19.6655 32.753 19.5283 32.42 19.5283 32.0728V28.1455C19.5283 27.7983 19.6655 27.4654 19.9096 27.2198C20.1538 26.9743 20.4849 26.8364 20.8302 26.8364C21.1755 26.8364 21.5066 26.9743 21.7508 27.2198C21.9949 27.4654 22.1321 27.7983 22.1321 28.1455V32.0728Z",
  fill: "#536897"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M6.50928 23.5636V36.6545C6.51175 37.5808 6.83974 38.4764 7.43531 39.1831C8.03088 39.8897 8.85569 40.362 9.76399 40.5163V19.7018C8.85569 19.8562 8.03088 20.3284 7.43531 21.0351C6.83974 21.7417 6.51175 22.6373 6.50928 23.5636V23.5636Z",
  fill: "#000028"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  d: "M31.896 19.7018V40.5163C32.8043 40.362 33.6291 39.8897 34.2247 39.1831C34.8202 38.4764 35.1482 37.5808 35.1507 36.6545V23.5636C35.1482 22.6373 34.8202 21.7417 34.2247 21.0351C33.6291 20.3284 32.8043 19.8562 31.896 19.7018V19.7018Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2451 19.6364H10.4149C8.2579 19.6364 6.50928 21.3947 6.50928 23.5636V36.6545C6.50928 38.8235 8.2579 40.5818 10.4149 40.5818H31.2451C33.4022 40.5818 35.1508 38.8235 35.1508 36.6545V23.5636C35.1508 21.3947 33.4022 19.6364 31.2451 19.6364Z",
  stroke: "#2E4369",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3682 19.6364V9.81817C12.3682 7.56142 13.2597 5.3971 14.8467 3.80134C16.4337 2.20557 18.5861 1.30908 20.8304 1.30908C23.0748 1.30908 25.2272 2.20557 26.8142 3.80134C28.4011 5.3971 29.2927 7.56142 29.2927 9.81817V19.6364H12.3682ZM22.1323 32.0727C22.1323 32.4199 21.9952 32.7529 21.751 32.9984C21.5069 33.2439 21.1757 33.3818 20.8304 33.3818C20.4851 33.3818 20.154 33.2439 19.9099 32.9984C19.6657 32.7529 19.5285 32.4199 19.5285 32.0727V28.1454C19.5285 27.7983 19.6657 27.4653 19.9099 27.2198C20.154 26.9743 20.4851 26.8364 20.8304 26.8364C21.1757 26.8364 21.5069 26.9743 21.751 27.2198C21.9952 27.4653 22.1323 27.7983 22.1323 28.1454V32.0727Z",
  stroke: "#2E4369",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9717 19.6363V9.81816C14.9717 8.25579 15.5889 6.75741 16.6876 5.65265C17.7863 4.54789 19.2764 3.92725 20.8302 3.92725C22.3839 3.92725 23.8741 4.54789 24.9728 5.65265C26.0714 6.75741 26.6887 8.25579 26.6887 9.81816V19.6363",
  stroke: "#2E4369",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5 46C41.299 46 46 41.299 46 35.5C46 29.701 41.299 25 35.5 25C29.701 25 25 29.701 25 35.5C25 41.299 29.701 46 35.5 46Z",
  fill: "#E3FFE4"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5 46C41.299 46 46 41.299 46 35.5C46 29.701 41.299 25 35.5 25C29.701 25 25 29.701 25 35.5C25 41.299 29.701 46 35.5 46Z",
  stroke: "#48568B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M40 32.5L34.75 38.5L31.75 35.5",
  stroke: "#48568B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgLockChecked = function SvgLockChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lockChecked.dac894db.svg";
export { ForwardRef as ReactComponent };